import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { opportunities, rakProjectFacts } from "@/data/projects";

const cardPrice = (project) => {
  const priceFact = (rakProjectFacts[project.slug] || []).find((fact) => fact.label === "Starting price");
  if (!priceFact || priceFact.value === "On request") return "Price on Request";
  const source = priceFact.source.toLowerCase();
  if (source.includes("portal") || source.includes("property finder") || source.includes("dubizzle")) return "Price on Request";
  return `${priceFact.value.split(";")[0].replace(" million", "m")} · developer-published`;
};

const ProjectCard = ({ project, index = 0 }) => {
  const basePath = opportunities.some((o) => o.slug === project.slug) ? "/opportunities" : "/developments";
  const ctaLabel = basePath === "/developments" ? "Request Details & Availability" : "View Details";
  return (
  <Link
    to={`${basePath}/${project.slug}`}
    data-testid={`project-card-${project.slug}`}
    className="card-hover group block bg-[#13151D] border border-[rgba(197,168,128,0.15)] rounded-2xl overflow-hidden"
  >
    <div className="relative h-60 overflow-hidden">
      <img src={project.image} alt={`${project.name}, ${project.location}`} loading={index > 2 ? "lazy" : "eager"} className="card-img w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C10]/85 via-transparent to-transparent" />
      <span className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.2em] font-semibold text-[#0B0C10] bg-gradient-to-r from-[#E6CA65] to-[#C5A880] px-3 py-1.5 rounded-full">
        {project.badge}
      </span>
      <span className="absolute bottom-4 right-4 w-9 h-9 rounded-full border border-[rgba(230,202,101,0.5)] flex items-center justify-center text-[#E6CA65] opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[#0B0C10]/60 backdrop-blur">
        <ArrowUpRight size={16} />
      </span>
    </div>
    <div className="p-6">
      <p className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] text-[#9DA3AE] mb-2">
        <MapPin size={12} className="text-[#C5A880]" /> {project.location}
      </p>
      <h3 data-testid="project-card-title" className="font-display text-xl text-[#F4F3EF] leading-snug mb-2 group-hover:text-[#E6CA65] transition-colors duration-300">
        {project.name}
      </h3>
      <p className="text-sm text-[#9DA3AE] font-light mb-4">{project.type}</p>
      <div className="flex items-center justify-between border-t border-[rgba(197,168,128,0.12)] pt-4">
        <span data-testid="project-card-price" className="text-xs text-[#E6CA65] font-medium">
          {cardPrice(project)}
        </span>
        <span className="text-[11px] uppercase tracking-[0.15em] text-[#C5A880]">{ctaLabel}</span>
      </div>
    </div>
    </Link>
  );
};

export default ProjectCard;
